import React, {useEffect} from 'react';

import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import { useDispatch, useSelector } from 'react-redux';

import { changeAccount, unchangeAccount } from '../store/app';
import { fetchAccounts } from '../store/resources';


export default function Accounts() {
  const dispatch = useDispatch();
  const accounts = useSelector(state => state.accounts);
  const account_id = useSelector(state => state.app.account_id);

  useEffect(() => {
    dispatch(fetchAccounts());
  }, [dispatch, account_id]);

  return (
    <div className="container px-0">
      <div className="row">
        <div className="col-12">
          <h3>Accounts</h3>
          {account_id !== 0 && (
            <div>
              <h5>Currently set to account {account_id},</h5>
              <p><Button onClick={() => dispatch(unchangeAccount())}>Back to my account</Button></p>
            </div>
          )}
          <Table striped bordered responsive>
            <thead>
              <tr>
                <th>&nbsp;</th><th>Account Name</th><th>Account ID</th><th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
            {accounts.map(account => (
              <tr key={account.id}>
                <td>{account_id === account.id && <strong>*</strong>}</td>
                <td>{account.name}</td><td>{account.id}</td>
                <td><Button onClick={() => dispatch(changeAccount(account.id))} variant="primary">Use</Button></td>
              </tr>
            ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
}
